import { render, staticRenderFns } from "./InvestmentNavigation.vue?vue&type=template&id=0398b240&"
import script from "./InvestmentNavigation.vue?vue&type=script&lang=js&"
export * from "./InvestmentNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports